module.exports = __webpack_public_path__ + "img/slogan.84c70114.png";